module.exports = __webpack_public_path__ + "static/media/computer_gears.a55feed2.png";